<template>
	<div class="home">
		<Top></Top>
		<Header></Header>
		<Swiper :swiperList='swiperList'></Swiper>
		<Nav></Nav>
		<QuickEntry :quickEntryList='quickEntryList'></QuickEntry>
		<Recommend :recommendList='recommendList'></Recommend>
		<!-- 在所有页面内容的下方，引入页脚 -->
		<Footer></Footer>
	</div>
</template>
<script type="text/javascript">
	import Top from '../../base/top.vue'
	import Header from '../../base/header.vue'
	import Swiper from '../../base/swiper.vue'
	import Nav from '../../base/nav.vue'
	import QuickEntry from '../../base/quickentry.vue'
	import Recommend from '../../base/recommend.vue'
	import Footer from '../../base/footer.vue'

	export default{
		created(){
			this.getIndexData()
		},
		components:{
			Top,
			Header,
			Swiper,
			Nav,
			QuickEntry,
			Recommend,
			Footer
		},
		data(){
			return{
				swiperList:[],
				quickEntryList:[],
				recommendList:[]
			}
		},
		methods:{
			getIndexData(){
				this.$axios.get('../../../static/mock/index.json')
						   .then((result)=>{
						   		if(result.data.ret===true){
						   			var dataList=result.data.data
						   			this.swiperList=dataList.swiperList
						   			this.quickEntryList=dataList.iconList
						   			this.recommendList=dataList.recommendList
						   		}
							})
			}
		},
	}
</script>
<style lang='less' scoped>
	.home{	
		padding-top: 82px;
		background: #f0f0f0;
	}

</style>


// WEBPACK FOOTER //
// src/components/Home/home.vue